import i18n from '@/utils/i18n';
import React from 'react';
import { PricingSearchEmptyState } from '@sales-portal/domain/pricing/components/pricing-search-empty-state';

interface Props {
  baseEmptyComponent: React.ReactNode;
  hasActiveFilters: boolean;
  onClear: () => void;
  searchText: string;
}

export const PricingFilterEmptyState: React.FC<Props> = ({
  baseEmptyComponent,
  hasActiveFilters,
  onClear,
  searchText,
}) => {
  if (searchText.length > 0) {
    return <PricingSearchEmptyState onClearSearch={onClear} />;
  }

  if (hasActiveFilters) {
    return (
      <PricingSearchEmptyState
        clearLabel={i18n.t('pricing.filters.clear_all')}
        description={i18n.t('pricing.filters.empty.description')}
        onClearSearch={onClear}
        title={i18n.t('pricing.filters.empty.title')}
      />
    );
  }

  return baseEmptyComponent;
};
